<template>
	<div class="login-page-container" a_id="edit-password-container" extension-name="reset-password">


		<span class="edit-password-guideline"
			  v-show="showPasswordGuideline"
			  a_id="edit-password-guideline">
			Password must include:<br>
			<div class="edit-password-guideline-rule"
				 a_id="edit-password-guideline-1">&gt; At least 8 characters long</div>
			<div class="edit-password-guideline-rule"
				 a_id="edit-password-guideline-2">&gt; At least 1 number</div>
			<div class="edit-password-guideline-rule"
				 a_id="edit-password-guideline-3">&gt; Uppercase alphabetic chars</div>
			<div class="edit-password-guideline-rule"
				 a_id="edit-password-guideline-4">&gt; Lowercase alphabetic chars</div>
			<div class="edit-password-guideline-rule"
				 a_id="edit-password-guideline-5">&gt; At least 1 special char</div>
		</span>

		<div class="login-page-header"
			 a_id="edit-password-header">
			{{title | translate}} <b>{{'EditPasswordPage.EditPasswordHeaderEnd' | translate}}</b>
		</div>

		<div class="edit-password-description"
			 a_id="edit-password-description">
			{{'EditPasswordPage.EditPasswordDecription' | translate}}
		</div>

		<login-page-field
				v-model="password"
				:title="'LoginPage.Password' | translate"
				:type="'password'"
				:placeholder="'EditPasswordPage.PasswordPlaceholderRequired' | translate"
				:image-type="'password'"
				:show-password-strength="password"
				@focus="setShowPasswordGuideline(true)"
				@blur="setShowPasswordGuideline(false)"
				@enter="resetClicked"
				@passwordStrong="setPasswordStrength"
				a_id="edit-password-field-password-1"/>


		<login-page-field
				v-model="password2"
				:title="'LoginPage.PasswordRetypeTitle' | translate"
				:type="'password'"
				:placeholder="'EditPasswordPage.RetypePasswordPlaceholderRequired' | translate"
				:image-type="'password_retype'"
				:show-error-message="(loginFailed || !validateBothPasswordsMatch()) && !!password2"
				:error-message="(errorMessage || 'LoginPageField.PasswordStrengthErrorMessage') | translate"
				@enter="resetClicked"
				@focus="setSecondPasswordActivated"
				a_id="edit-password-field-password-2"/>

		<div class="login-page-footer"
			 a_id="edit-password-footer">
			<button v-if="resetButtonEnabled"
					class="login-page-footer-button-right"
					@click="resetClicked"
					a_id="edit-password-footer-reset-button">
				{{'LoginPage.ResetPassword' | translate}}
			</button>
			<button v-else
					class="login-page-footer-button-right"
					disabled
					a_id="edit-password-footer-reset-button-disabled">{{ buttonTitle | translate}}
			</button>
		</div>
	</div>
</template>

<script>
	import BasePage from './BasePage.vue';
	import LoginPageField from './LoginPageField.vue';
	import LoginService from '../services/LoginService';
	import UrlService from '../../../common/services/src/url/urlService';

	export default BasePage.extend({
		name: "EditPasswordPage",
		props:{
			"currentAccountId" : {
				type: String,
				required: false
			}
		},
		methods: {
			resetClicked(){
				if(!this.password || !this.password2 || (this.password != this.password2)){
					return;
				}
				let accountId = UrlService.getSearchParam("accountId") || UrlService.getSearchParam("account");
				LoginService.resetPassword(accountId, 'loginapplicationkey', this.password, this.verificationKey).then(
						(res) => {

							let userName = res.data.name;

							LoginService.auth(accountId, userName, this.password, 'loginapplicationkey').then(
									(res) => {


										/* Check if this user has only the AGENT ROLE */
										if(res.data.roles && res.data.roles.length === 1) {

											if(res.data.roles[0] === "ROLE_AGENT" && !LoginService.isTargetAgentApp()) {

												var errorMsg = this.translateService.getString('EditPasswordPage.AgentAppUser');

												this.$emit('notify',
														this.translateService.getString('EditPasswordPage.ResetPassword'),
														errorMsg);

												/* Notify that the user must login to agent app */
												this.loginFailed = true;
												this.errorMessage = errorMsg;

												this.canResetPassword = false;

												return;
											}
										}

										this.loginFailed = false;
										LoginService.keepLoginInfo(userName, accountId);
										if(!res.data.mfa){
											this.$emit("navigate", "LoginMFAPage");
											return;
										}

										// set the Cookies && Local/Session storage(will be used by all the Apps)
										LoginService.updateLoginData(res.data["Access-Token"], res.data.userId, res.data["roles"]);

										//  redirect to previous APP
										LoginService.redirectToApp(accountId);
									},
									(err) => {

										/* Clear the login data */
										LoginService.updateLoginData("", "", "", "", "");

										//  redirect to previous APP
										LoginService.redirectToApp(accountId);
									}
							);
						},
						(err) => {
							this.$emit('notify',
									this.translateService.getString('EditPasswordPage.ResetPasswordFailure'),
									this.extractErrorMessage(err.data.message));
						}
				);
			},
			validateBothPasswordsMatch(){
				// ignore, till User started re-typing the second password
				if(!this.secondPasswordActivated)
					return true;
				return this.password === this.password2;
			},
			setShowPasswordGuideline(shouldShow){
				this.showPasswordGuideline = shouldShow;
			},
			setSecondPasswordActivated(){
				this.secondPasswordActivated = true;
			},
			setPasswordStrength(isStrongPwd){
				this.isStrongPassword = isStrongPwd;
			}

		},
		data(){
			return {
				password: '',
				password2: '',
				canResetPassword : true,
				loginFailed: false,
				errorMessage : "",
				showPasswordGuideline: false,
				verificationKey: '',
				secondPasswordActivated: false,
				title: "",
				buttonTitle: "",
				isStrongPassword: false
			};
		},
		components: {
			LoginPageField
		},
		model: {
			// Parent can use "v-model" (by default, the expected event's name is "input")
			event: "navigate"
		},
		mounted(){
			let accountId = UrlService.getSearchParam('accountId') || UrlService.getSearchParam('account');
			if(accountId) {
				this.accountId = accountId;
			}
			this.verificationKey = UrlService.getSearchParam('key');

			let path = window.location.href;
			if(path.indexOf("change-password") > -1) {
				this.title = 'EditPasswordPage.EditPasswordHeaderStart_Choose';
				this.buttonTitle = 'LoginPage.SendPassword';
			}
			else {
				this.title = 'EditPasswordPage.EditPasswordHeaderStart_Reset';
				this.buttonTitle = 'LoginPage.ResetPassword';
			}

		},
		dependencies: [{
			translateService : 'com.jacada.common.services.TranslateService'
		}],
		computed: {
			resetButtonEnabled(){
				return this.password
						&& this.password2
						&& (this.password === this.password2)
						&& this.canResetPassword
						&& this.isStrongPassword;
			}
		}
	});
</script>

<style lang="scss">
	@import '../sass/loginPage.scss';

	.login-page-container {

		.edit-password-description{
			line-height: 24px;
			font-size: 16px;
			max-width: 365px;
		}

		.edit-password-guideline{
			width: 220px;
			font-family: Roboto-Regular;
			font-size: 11px;
			color: #404e63;

			float: right;
			position: relative;
			left: 260px;
			top: 150px;

			.edit-password-guideline-rule{
				color: #202aa7;
				line-height: 24px;
				max-width: 200px;
			}

		}

	}

</style>



// WEBPACK FOOTER //
// src/app/EditPasswordPage.vue